import type { ModalBodyProps as ChakraModalBodyProps } from '@chakra-ui/react';
import { ModalBody as ChakraModalBody } from '@chakra-ui/react';
import React, { useCallback, useState } from 'react';

import { useScrollLocation } from '../../hooks/useScrollLocation';
import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export interface ModalBodyProps extends OmitChakraProps<ChakraModalBodyProps> {
  isScrollable?: boolean;
  ref?: React.Ref<HTMLDivElement>;
}

export const ModalBody = withChakraAs<ModalBodyProps, 'div'>(
  ({ isScrollable = true, ref, ...props }) => {
    const [modalBodyRef, setRef] = useState<HTMLDivElement | null>(null);
    const scrollLocation = useScrollLocation(modalBodyRef);

    const updateRef = useCallback(
      (element: HTMLDivElement | null) => {
        setRef(element);

        if (!ref) {
          return;
        }

        if (typeof ref === 'function') {
          return ref(element);
        } else {
          // eslint-disable-next-line no-param-reassign
          ref.current = element;
        }
      },
      [ref],
    );

    return (
      <ChakraModalBody
        data-scroll-location={scrollLocation}
        ref={isScrollable ? updateRef : ref}
        overflowY={isScrollable ? 'auto' : undefined}
        {...props}
      />
    );
  },
);
